import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const LockAccountConfirmationModal = ({  isOpen, onLockAccountClick, onCloseClick }) => {
  return (
    <Modal size="md"  isOpen={isOpen} toggle={onCloseClick} centered={true} backdrop="static">
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="bx bx-lock "></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">Etes-vous sûr de vouloir désactiver ce compte ?</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="btn btn-danger" onClick={onLockAccountClick}>Désactiver</button>
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>Fermer</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

LockAccountConfirmationModal.propTypes = {
  onCloseClick: PropTypes.func,
  onLockAccountClick: PropTypes.func,
  isOpen: PropTypes.any
}

export default LockAccountConfirmationModal